(() => {
  if (window.SCThemeMode) {
    window.SCThemeMode.refresh();
    return;
  }
  const root = document.documentElement;
  const storageKey = 'strongclub-theme';
  const valid = value => value === 'light' || value === 'dark';
  const read = () => {
    try {
      const value = localStorage.getItem(storageKey);
      return valid(value) ? value : null;
    } catch (error) {
      return null;
    }
  };
  let preference = read();
  let mode = preference || 'light';
  const refresh = (scope = document) => {
    const buttons = scope.matches?.('[data-sc-theme-toggle]') ? [scope] : scope.querySelectorAll('[data-sc-theme-toggle]');
    buttons.forEach(button => {
      const label = mode === 'dark' ? button.dataset.lightLabel : button.dataset.darkLabel;
      button.setAttribute('aria-label', label);
      button.title = label;
      button.hidden = false;
    });
  };
  const apply = (next, save = false) => {
    mode = next;
    root.dataset.scTheme = mode;
    root.style.colorScheme = mode;
    if (save) {
      preference = mode;
      try { localStorage.setItem(storageKey, mode); } catch (error) {}
    }
    refresh();
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-sc-theme-toggle]');
    if (!button) return;
    apply(mode === 'dark' ? 'light' : 'dark', true);
  });
  document.addEventListener('shopify:section:load', event => refresh(event.target));
  window.addEventListener('storage', event => {
    if (event.key !== storageKey && event.key !== null) return;
    preference = read();
    apply(preference || 'light');
  });
  window.SCThemeMode = { refresh };
  apply(mode);
})();

